export default "__VITE_ASSET__BeY$cD8i__"